<template>
    <div class="profile-page">

        <!-- HERO -->
        <div class="profile-hero">
            <profile-avatar :img="studentImg" :name="studentName" :subtitle="currentCoach" show-name />
            <rate-coach v-if="coachId" />
        </div>

        <!-- ACCORDIONS -->
        <div class="accordions">
            <expanded-sections :sections="sections" eager>
                <template #objectives>
                    <objectives-profile :student="account" />
                </template>

                <template #action-injuries>
                    <accordion-add-button :tooltip="`${$t('common.add')} ${$t('common.injury')}`"
                        @click="$refs.injuries.showInjuryForm()" />
                </template>
                <template #injuries>
                    <injuries-card ref="injuries" :coachId="coachId" :student-id="studentId" addButton header-add />
                </template>

                <template #evaluations>
                    <plan-required-content v-if="!can('studentEvaluations')" feature="studentEvaluations" />
                    <reports-card v-else :student-id="studentId" />
                </template>
                <template #files>
                    <plan-required-content v-if="!can('studentFiles')" feature="studentFiles" />
                    <files-student-section v-else :coachId="coachId" :student-id="studentId" />
                </template>
            </expanded-sections>
        </div>

    </div>
</template>

<script>

import InjuriesCard from "@/components/student/InjuriesCard";
import ReportsCard from '../../components/student/ReportsCard.vue';
import ExpandedSections from '../../components/common/ExpandedSections.vue';
import ObjectivesProfile from '../../components/elements/profile/ObjectivesProfile.vue';
import FilesStudentSection from '../../components/coach/FilesStudentSection.vue';
import RateCoach from '../../components/student/RateCoach.vue';
import ProfileAvatar from '../../components/common/ProfileAvatar.vue';
import AccordionAddButton from '../../components/common/AccordionAddButton.vue';
import PlanRequiredContent from '../../components/common/PlanRequiredContent.vue';

export default {
    components: {
        InjuriesCard,
        ReportsCard,
        ExpandedSections,
        ObjectivesProfile,
        FilesStudentSection,
        RateCoach,
        ProfileAvatar,
        AccordionAddButton,
        PlanRequiredContent
    },
    computed: {
        sections(vm = this) {
            return [
                { title: vm.$t('common.objectives'), value: 'objectives' },
                { title: vm.$t('common.injuries'), value: 'injuries' },
                { title: vm.$t('common.evaluations'), value: 'evaluations', feature: 'studentEvaluations' },
                { title: vm.$t('common.files'), value: 'files', feature: 'studentFiles' },
            ]
        },
        studentId(vm = this) {
            return vm.currentUser?.uid || null
        },
        studentImg(vm = this) {
            return vm.currentUser?.photoURL || vm.account?.avatar || null
        },
        studentName(vm = this) {
            return vm.account?.name || '-'
        },
        coachName(vm = this) {
            return vm.account?.studentSubscription?.coachName || null
        },
        currentCoach(vm = this) {
            return vm.coachName ?
                `${vm.$tc('coach.coach', 1)}: ${vm.coachName}` :
                vm.$t('coach.no_hired_coach')
        },
        coachId(vm = this) {
            return vm.account?.studentSubscription?.coachId || null
        }
    }
}
</script>

<style scoped>
.profile-page {
    max-width: 600px;
    width: 100%;
    margin: 0 auto;
    padding-bottom: 40px;
}

.profile-hero {
    background: var(--v-surface-base);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 28px 20px 24px;
    border-bottom: 1px solid var(--v-outline-base);
}

.accordions {
    margin: 12px 0;
}
</style>
